// account
export const SIGNUP_URL = '/auth/signup';
export const SIGNUP_OAUTH_URL = '/auth/signupOAuth';
export const LOGIN_URL = '/auth/login';
export const LOGIN_OAUTH_URL = '/auth/loginOAuth';
export const LOGOUT_URL = '/auth/logout';
export const FORGOT_PASSWORD_URL = '/auth/forgotPassword';
export const RESET_PASSWORD = '/auth/resetPassword';
export const RESET_PASSWORD_AUTHED_URL = '/auth/resetPasswordAuthed';
export const SET_PASSWORD_AND_VERIFY_URL = '/auth/setPasswordAndVerify';
export const REQUEST_SET_PASSWORD_AND_VERIFY_URL =
  '/auth/requestSetPasswordAndVerifyLink';
export const REQUEST_EMAIL_VERIFICATION = '/auth/requestEmailVerificationLink';
export const VERIFY_EMAIL_URL = '/auth/verifyEmail';

// user
export const GET_USER_URL = '/user';
export const GET_USER_STATS_URL = '/user/stats';
export const REGISTER_USER_URL = '/user';
export const INVITE_USER_URL = '/user/invite';
export const RESEND_INVITATION_URL = '/user/resendInvitation';
export const EDIT_USER_URL = '/user';
export const TOGGLE_USER_IS_ACTIVE_URL = '/user/isActive';
export const DELETE_USER_URL = '/user';

// organization
export const GET_ORGANIZATION_URL = '/organization';
export const GET_ORGANIZATION_STATS_URL = '/organization/stats';
export const REGISTER_ORGANIZATION_URL = '/organization';
export const SIGNUP_ORGANIZATION_URL = '/organization/signup';
export const EDIT_ORGANIZATION_URL = '/organization';
export const TOGGLE_ORGANIZATION_IS_ACTIVE_URL = '/organization/isActive';
export const SET_ORGANIZATION_APPS_URL = '/organization/apps';
export const ARCHIVE_ORGANIZATION_URL = '/organization/archive';
export const DELETE_ORGANIZATION_URL = '/organization';

// screen
export const GET_SCREEN_URL = '/screen';
export const GET_SCREENS_UNPOPULATED_URL = '/screen/unpopulated';
export const REGISTER_SCREEN_URL = '/screen';
export const EDIT_SCREEN_URL = '/screen';
export const UPDATE_SCREEN_LOCATION_URL = '/screen/location';
export const TOGGLE_SCREEN_IS_ACTIVE_URL = '/screen/isActive';
export const DELETE_SCREEN_URL = '/screen';

// ticket
export const TICKET_URL = '/ticket'
export const ADD_TICKET_URL = '/ticket/add'
export const EDIT_TICKET_URL = '/ticket/edit'
export const CLOSE_TICKET_URL = '/ticket/close'
export const DELETE_TICKET_URL = '/ticket'
export const TICKET_UNREAD_URL = '/ticket/unread'

// ticket
export const TICKET_COMMENT_URL = '/ticketComment'
export const ADD_TICKET_COMMENT_URL = '/ticketComment/add'
export const EDIT_TICKET_COMMENT_URL = '/ticketComment/edit'
export const DELETE_TICKET_COMMENT_URL = '/ticketComment'

// activity log
export const ACTIVITY_LOG_URL = '/activityLog'

// dashboard
export const DASHBOARD_URL = '/dashboard'

// support session (Screenkode staff inside an organization's app)
export const SUPPORT_SESSION_URL = '/supportSession'

// Kode AI: its use of Gemini, and the free-tier limits that counts against
export const KODE_AI_USAGE_URL = '/kodeAi/usage';
export const KODE_AI_LIMITS_URL = '/kodeAi/limits';
